import { Fragment, useState, useContext } from "react";
import { Form, FormGroup, Input, Label, Container, Row, Col, TabContent, TabPane } from "reactstrap";
import { Btn, P, Image } from "../../../AbstractElements";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { onboardingSetNewPassword } from "../../../store/slices/authNewSlice";
import CustomizerContext from "../../../_helper/Customizer";
import DashboardIcon from "../../../assets/images/logo/img1.png";
import CubaIcon from "../../../assets/images/logo/logo.png";
import Swal from "sweetalert2";

const SetPassword = () => {
  const history = useNavigate();
  const location = useLocation();
  const { layoutURL } = useContext(CustomizerContext);
  const dispatch = useDispatch();

  const { loading, errorSetPassword } = useSelector((state) => state.auth);

  const user = location?.state?.user;
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [validationError, setValidationError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setValidationError("");

    if (!newPassword || !confirmPassword) {
      setValidationError("Please fill in both password fields.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setValidationError("Passwords do not match.");
      return;
    }

    if (newPassword.length < 6) {
      setValidationError("Password must be at least 6 characters long.");
      return;
    }

    if (!user?.id) {
      setValidationError("Session expired. Please login again.");
      return;
    }

    await dispatch(
      onboardingSetNewPassword({
        userId: user.id,
        newPassword,
      })
    )
      .unwrap()
      .then(() => {
        Swal.fire({
          title: "Password Set Successfully",
          text: "Your new password has been saved. You will now be redirected to the dashboard.",
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          history(`${process.env.PUBLIC_URL}/pages/dashboard`);
        });
      })
      .catch((err) => {
        console.error("Failed to set new password:", err);
      });
  };
  return (
    <Container fluid={true} className="p-0 login-page">
      <Row>
        <Col xs="12">
          <div className="login-card">
            <Image
              attrImage={{
                className: "img-fluid d-inline",
                src: `${DashboardIcon}`,
                alt: "",
                style: { width: "50%", height: "25%" },
              }}
            />
            <div className="login-main login-tab">
              <TabContent className="content-login">
                <TabPane className="fade show">
                  <Fragment>
                    <div className="text-center">
                      <Link
                        to={`${process.env.PUBLIC_URL}/pages/sample-page/${layoutURL}`}
                      >
                        <Image
                          attrImage={{
                            className: "img-fluid d-inline",
                            src: `${CubaIcon}`,
                            alt: "",
                          }}
                        />
                      </Link>
                      <h5 className="mt-3">Set New Password</h5>
                      <p
                        className="mt-2"
                        style={{ color: "#888", fontSize: "14px" }}
                      >
                        Your password has expired. Please set a new password to
                        continue.
                      </p>
                    </div>
                    <Form className="theme-form" onSubmit={handleSubmit}>
                      <FormGroup className="position-relative">
                        <Label
                          className="col-form-label"
                          htmlFor="new-password"
                        >
                          New Password
                        </Label>
                        <div className="position-relative">
                          <Input
                            className="form-control"
                            type={showPassword ? "text" : "password"}
                            id="new-password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            required
                          />
                          <button
                            type="button"
                            className="show-hide"
                            onClick={() => setShowPassword(!showPassword)}
                            aria-label="Toggle password visibility"
                          >
                            <span className={showPassword ? "" : "show"}>
                              <i
                                className={`fa ${
                                  showPassword ? "fa-eye-slash" : "fa-eye"
                                }`}
                              ></i>
                            </span>
                          </button>
                        </div>
                      </FormGroup>
                      <FormGroup className="position-relative">
                        <Label
                          className="col-form-label"
                          htmlFor="confirm-password"
                        >
                          Confirm Password
                        </Label>
                        <div className="position-relative">
                          <Input
                            className="form-control"
                            type={showConfirmPassword ? "text" : "password"}
                            id="confirm-password"
                            value={confirmPassword}
                            onChange={(e) =>
                              setConfirmPassword(e.target.value)
                            }
                            required
                          />
                          <button
                            type="button"
                            className="show-hide"
                            onClick={() =>
                              setShowConfirmPassword(!showConfirmPassword)
                            }
                            aria-label="Toggle confirm password visibility"
                          >
                            <span
                              className={showConfirmPassword ? "" : "show"}
                            >
                              <i
                                className={`fa ${
                                  showConfirmPassword
                                    ? "fa-eye-slash"
                                    : "fa-eye"
                                }`}
                              ></i>
                            </span>
                          </button>
                        </div>
                      </FormGroup>

                      {validationError && (
                        <P
                          style={{
                            color: "red",
                            textAlign: "center",
                            marginTop: "10px",
                          }}
                        >
                          {validationError}
                        </P>
                      )}

                      {errorSetPassword && (
                        <P
                          style={{
                            color: "red",
                            textAlign: "center",
                            marginTop: "10px",
                          }}
                        >
                          {typeof errorSetPassword === "string"
                            ? errorSetPassword
                            : errorSetPassword?.message ||
                              "Failed to set password."}
                        </P>
                      )}

                      <div className="position-relative form-group mb-0">
                        <Btn
                          attrBtn={{
                            color: "danger",
                            type: "submit",
                            style: { order: 2 },
                            disabled: loading,
                          }}
                        >
                          {loading ? "Setting Password..." : "Set Password"}
                        </Btn>
                      </div>
                    </Form>
                  </Fragment>
                </TabPane>
              </TabContent>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default SetPassword;
